import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { PGWContractRateContainerModel} from "../../../../../models/aggregates/pgw/pgw-contract-rate.model";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../shared";
import {
  PGWContractRateQueryCriteriaClass,
  PGWContractRateCriteriaModelQuery,
} from "../../criteria/pgw/pgw-contract-rate-criteria.model";

@Injectable({
  providedIn: "root",
})
export class PGWContractRateService extends BaseApiTemplateService<PGWContractRateContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "contract-rates";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "contract-rates";
    this.httpClient = http;
  }

  getPGWContractRateByCriteria(
    visa: ApiVisa,
    criteria?: PGWContractRateQueryCriteriaClass
  ): Observable<PagingResponseModel<PGWContractRateContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildPGWContractRateCriteria = new PGWContractRateCriteriaModelQuery(criteria);
    console.log("query", buildPGWContractRateCriteria.query);
    return this.httpClient.get<PagingResponseModel<PGWContractRateContainerModel>>(
      this.apiUrl + "/query?" + buildPGWContractRateCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
